import { Divider, ListCard, Text } from '@capsicum/common-web';
import styled from 'styled-components';

export namespace S {
	export const TitleContainer = styled.div`
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(0, max-content));
		gap: ${({ theme }) => theme.spacings.xxsmall};
		margin: 0 0 ${({ theme }) => theme.spacings.xxsmall};
		align-items: center;
	`;

	export const Container = styled(ListCard)<{ $interactive: boolean; $selected: boolean }>`
		height: auto;
		outline: ${({ $selected, theme }) =>
			$selected ? theme.border.width.small + ' solid ' + theme.colors.borders.brand.selected : 'none'};
		cursor: ${({ $interactive }) => ($interactive ? 'pointer' : 'auto')};
	`;

	export const Content = styled(ListCard.Content)<{ $interactive: boolean }>`
		padding-left: ${({ theme }) => theme.spacings.small};
		padding-right: ${({ theme }) => theme.spacings.small};
		overflow: hidden;
		display: inline-block;
	`;

	export const ContentTop = styled.div`
		display: flex;
		gap: ${({ theme }) => theme.spacings.xxsmall};
	`;

	export const End = styled(ListCard.End)`
		margin: 0;
	`;

	export const NetworkDivider = styled(Divider)`
		margin: ${({ theme }) => theme.spacings.xsmall} 0px;
	`;

	export const Network = styled.div`
		display: flex;
		gap: ${({ theme }) => theme.spacings.xxsmall};
		padding-bottom: ${({ theme }) => theme.spacings.xsmall};
	`;
	export const NetworkLabel = styled(Text)``;
	export const NetworkExchange = styled(Text)``;
	export const Address = styled(Text)`
		margin: 0;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	`;
	export const ListCardTitle = styled(ListCard.Title)`
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		/* Add safe space for same letter like J to avoid by hidden by overflow */
		padding: 0 ${({ theme }) => theme.spacings.xxxxsmall};
		color: ${({ theme }) => theme.colors.text.main.enabled};
	`;
	export const TitleWrapper = styled.div`
		width: 100%;
	`;
}
